module.exports = __webpack_public_path__ + "img/new_logo_lit.68deb398.png";